module.exports = __webpack_public_path__ + "static/media/4.8ac28a1.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/majors/4.wav
// module id = z9Ws
// module chunks = 0